import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { ApiError, BaseReportService, ButtonLoader, MessageService } from '../../../../core';
import { AtividadeRelatorioApi } from '../../../../domains/relatorios/atividade/apis/atividade-relatorio.api';
import { agrupamentoPorPrazo } from '../../../../domains/relatorios/atividade/interfaces/agrupamento-atividade.interface';
import { IAtividadeFiltro } from '../../../../domains/relatorios/atividade/interfaces/atividade-filtro.interface';
import { AtividadeSearchAtividade } from '../../../atividade/atividade-search';
import { AtividadeFilter } from '../../../atividade/filter/atividade-filter';
import { AtividadeVisualizacao, AtividadeVisualizacaoComponent } from '../../../atividade/visualizacao';
import { visibilidadeTodas } from '../../../atividade/filter/visibilidade';
import { AtividadeFilterComponent } from '../../../atividade/filter/atividade-filter.component';
import { AtividadeFormModalComponent } from '../../../atividade/form-modal/atividade-form-modal.component';
import { AtividadeCalendarComponent } from '../../../atividade/calendar';
import { AtividadeListComponent } from '../../../atividade/list/atividade-list.component';
import { AtividadeCrudHttpService } from '../../../atividade/services/atividade-crud-http.service';

@Component({
    selector: 'sgt-cliente-atividade',
    templateUrl: './cliente-atividade.component.html',
    styleUrls: ['./cliente-atividade.component.less']
})
export class ClienteAtividadeComponent implements OnInit {
    @Input() idCliente: number;

    isSearchInsideTabInitialized = false; // Se já iniciou a consulta quando estiver dentro de uma aba

    // Filter
    filter: AtividadeFilter;
    @ViewChild('filterComponent') filterComponent: AtividadeFilterComponent;

    // Visualização
    visualizacao = new AtividadeVisualizacao();
    @ViewChild('visualizacaoComponent') visualizacaoComponent: AtividadeVisualizacaoComponent;

    @ViewChild('atividadeCalendar') atividadeCalendar: AtividadeCalendarComponent;
    @ViewChild('atividadeList') atividadeList: AtividadeListComponent;
    @ViewChild('formModal') formModal: AtividadeFormModalComponent;

    constructor(private baseReportService: BaseReportService,
                private messageService: MessageService,
                private atividadeCrudHttpService: AtividadeCrudHttpService,
                private atividadeRelatorioApi: AtividadeRelatorioApi) { }


    ngOnInit() {
        this.filter = new AtividadeFilter();
    }

    /** Ao iniciar o filtro */
    onFilterInitialized() {
        // Setando todas as atividades
        this.filter.visibilidade = visibilidadeTodas.id;
    }

    onFilterChange() {
        this.search();
    }

    onChangeModoVisualizacao() {
        this.search();
    }

    /** Realiza a pesquisa quando estiver dentro de uma aba */
    searchInsideTab() {
        // Somente consulta uma única vez
        if (this.isSearchInsideTabInitialized) {
            return;
        }

        this.search();
        this.isSearchInsideTabInitialized = true;
    }

    search() {
        // Setando o cliente no filter
        this.filter.idsClientes = [this.idCliente];

        if (this.visualizacaoComponent.isModoCalendar()) {
            this.atividadeCalendar.search();
        } else if (this.visualizacaoComponent.isModoList()) {
            this.atividadeList.search();
        }
    }

    refresh() {
        if (this.visualizacaoComponent.isModoCalendar()) {
            this.atividadeCalendar.search();
        } else if (this.visualizacaoComponent.isModoList()) {
            this.atividadeList.refresh();
        }
    }

    insert() {
        this.formModal?.insert(this.idCliente);
    }

    edit(atividade: AtividadeSearchAtividade) {
        this.formModal?.edit(atividade?.id);
    }

    delete(atividade: AtividadeSearchAtividade) {
        if (!atividade) {
            return;
        }

        this.messageService.confirm(`Deseja realmente excluir a atividade ${atividade.titulo}?`).then((result) => {
            if (result) {
                this.atividadeCrudHttpService.delete(atividade.id)
                    .subscribe(
                        () => {
                            this.messageService.success('', `Atividade ${atividade.titulo} excluída com sucesso`);
                            this.refresh();
                        },
                        (error: ApiError) => this.messageService.error(error.message, 'Ocorreu um erro ao excluir a atividade', error)
                    );
            }
        });
    }

    afterSave() {
        this.refresh();
    }

    /** Realiza a impressão as atividades na semata pesquisa agrupando por dia */
    print() {
        const btnPrint = new ButtonLoader('#btnPrint');
        btnPrint.loading('Imprimindo');

        const reportFilter: IAtividadeFiltro = {
            visibilidade: this.filter?.visibilidade,
            idCliente: this.idCliente,
            dataInicial: this.filter?.diaPrazoInicial,
            dataFinal: this.filter?.diaPrazoFinal,
            idsUsuariosDestino: this.filter?.idsUsuariosDestino ?? [],
            tipoEntrarEmContato: this.filter?.comTipoEntrarEmContato,
            tipoVisitar: this.filter?.comTipoVisitar,
            tipoTarefa: this.filter?.comTipoTarefa,
            tipoClienteNovo: this.filter?.comTipoClienteNovo,
            tipoClientePreInativo: this.filter?.comTipoClientePreInativo,
            tipoClienteInativo: this.filter?.comTipoClienteInativo,
            tipoClienteRevisao: this.filter?.comTipoClienteRevisao,
            tipoClienteTituloVencido: this.filter?.comTipoClienteTituloVencido,
            atrasada: true,
            concluida: true,
            emDia: true,
            agruparPor: agrupamentoPorPrazo.id,
        };

        this.atividadeRelatorioApi.imprimir(reportFilter)
        .subscribe(
            pdf => {
                btnPrint.reset();
                this.baseReportService.open(pdf);
            },
            error => {
                btnPrint.reset();
                this.baseReportService.openError(error);
            }
        );
    }
}
